import { createAsyncThunk } from "@reduxjs/toolkit";

const apiKey = process.env.REACT_APP_SPOONACULAR_API_KEY;

export const fetchRecipes = createAsyncThunk(
  "searchResults/fetchRecipes",
  async ({ query, ingredients }, thunkAPI) => {
    try {
      query = (query || "").trim();
      const includeIngredients = ingredients.join(",");

      const searchUrl = `https://api.spoonacular.com/recipes/complexSearch?query=${query}&includeIngredients=${includeIngredients}&number=20&apiKey=${apiKey}`;
      const searchResponse = await fetch(searchUrl);
      const searchData = await searchResponse.json();

      const recipeIDs = Array.isArray(searchData.results)
        ? searchData.results.map((r) => r.id).join(",")
        : "";

      if (!recipeIDs) {
        return thunkAPI.rejectWithValue("No recipes found");
      }

      const infoUrl = `https://api.spoonacular.com/recipes/informationBulk?ids=${recipeIDs}&apiKey=${apiKey}`;
      const infoResponse = await fetch(infoUrl);
      const infoData = await infoResponse.json();

      return infoData;
    } catch (error) {
      console.error("Error fetching recipes:", error);
      return thunkAPI.rejectWithValue("Failed to fetch recipes");
    }
  }
);
